<template>
  <span>{{value | formatDecimal(precision, true)}} <span v-html="uomDisplayUnits" /></span>
</template>

<script>
import { UOMTypeUnitsLookup } from '@/store/types'
import Utils from '@/utils/utils'

export default {
  name: 'UOMValue',
  props: {
    value: {
      type: Number,
      default: 0
    },
    uomType: String,
    precision: {
      type: Number,
      default: 5
    },
  },
  computed: {
    uomDisplayUnits() {
      return Utils.getLookupName(UOMTypeUnitsLookup, this.$props.uomType)
    },
  }
}
</script>